import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import { PlusIcon } from "../../../../common/imagePath";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  CUSTOM_SELECT_DROPDOWN_STYLE
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";

//MUI Table
import { MaterialReactTable } from "material-react-table";
// import { MenuItem } from "@mui/material";
// import { Box, Button } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "add-tags";
let PERMISSION_EDIT = "edit-tags";
let PERMISSION_DELETE = "delete-tags";

const Tags = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [showEditModel, setShowEditModel] = useState(false);
  const [formValues, setFormValues] = useState({ ID: 0, Name: "", TagType: "" });
  const [searchtext, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(4);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedData, setSelectedData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  let navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Tag name is required"),
  });
  const [editModalOpen, setEditModalOpen] = useState(false);
  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //dropdown options
  const options = [
    { value: "Account", label: "Account" },
    { value: "Portal", label: "Portal" },
  ];

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "") 
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index+1, 
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0 
      };
    });


    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(`${config.tagBaseUrl}/tags?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${sorting[0]?.desc === undefined
          ? "desc"
          : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${globalFilter === undefined ? "" : globalFilter
        }`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setData(res.data.ResponseData);
        setRowCount(res.data.ResponseData[0]?.TotalRecord)
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  console.log(data);
  useEffect(() => {
    handleListData(1, perPage, searchtext, sortingId, sortingDirection);
  }, [columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting]);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.tagBaseUrl}/tags/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const tagData = res.data.ResponseData[0];
        console.log(tagData);

        const data = {
          ID: tagData.ID,
          Name: tagData.Name,
          TagType: tagData.TagType,
        };
        setFormValues(data);
        setSelectedOption(
          options.find((option) => option.value === tagData.TagType)
        );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    setLoading(true);
    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    data[row.index] = values;
    // //send/receive api updates here
    setData([...data]);
    console.log(row.original, values, "roweditmode");

    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: row.original.ID,
          ecommerecetagid: "",
          name: values.Name,
          tagtype: values.TagType,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setLoading(false);
          handleListData();
          window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);

          // setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
    exitEditingMode(); //required to exit editing mode
  };

  // Create and Update Data
  const handleSubmit = async () => {
    setLoading(true);
    console.log(formValues.Name, "response11")
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: formValues.ID,
          ecommerecetagid: "",
          name: formValues.Name,
          tagtype: selectedOption.value,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setEditModalOpen(false)
          // handleListData();
          setLoading(false);
          window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };


  // Delete Tag
  // const handleDeletePopup = (pID) => {
  //   console.log(pID,"data230")
  //   const deleteRequestParam = {
  //     id: pID,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      id: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = { ID: 0, Name: "" };
    setFormValues(clearData);
  };

  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group" >
  //           {
  //             checkUserPermission(PERMISSION_EDIT) ?
  //               (
  //                 <Link className="btn btn-primary btn-sm btn-custom-padding"
  //                   to="#"
  //                   data-bs-toggle="modal"
  //                   data-bs-target="#ManageDataModal"
  //                   data-backdrop="static"
  //                   data-keyboard="false"
  //                   onClick={() => handleUpdate(row.ID)}
  //                 >
  //                   Edit
  //                 </Link>
  //               ) :
  //               ""
  //           }
  //           {
  //             checkUserPermission(PERMISSION_DELETE) ?
  //               (
  //                 <Link
  //                   className="btn btn-primary btn-sm btn-custom-padding confirm-text ml-2"
  //                   to="#"
  //                   title="Delete"
  //                   data-bs-toggle="modal"
  //                   data-bs-target="#DeleteConfirmationModal"
  //                   onClick={() => handleDeletePopup(row.ID)}
  //                 >
  //                   Delete
  //                 </Link>
  //               ) : ""
  //           }
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     //width: "7%",//"100px",
  //     minWidth: "100px",
  //     width: "120px",
  //   },
  //   {
  //     name: "Tags",
  //     // selector: "Name",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Name}>
  //         {row.Name}
  //       </p>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Tag Type",
  //     // selector: "TagType",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.TagType}>
  //         {row.TagType}
  //       </p>
  //     ),
  //     sortable: true,
  //   },
  //   // {
  //   //   name: "Action",
  //   //   width: "20%",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {/* Edit Record Button  */}
  //   //       {checkUserPermission(PERMISSION_EDIT) ? (
  //   //         <Link
  //   //           className="me-3"
  //   //           to="#"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#ManageDataModal"
  //   //           data-backdrop="static"
  //   //           data-keyboard="false"
  //   //           onClick={() => handleUpdate(row.ID)}
  //   //         >
  //   //           <i class="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}

  //   //       {/** Delete Record Button */}
  //   //       {checkUserPermission(PERMISSION_DELETE) ? (
  //   //         <Link
  //   //           className="confirm-text"
  //   //           to="#"
  //   //           title="Delete"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#DeleteConfirmationModal"
  //   //           onClick={() => handleDeletePopup(row.ID)}
  //   //         >
  //   //           <i
  //   //             class="fa fa-trash text-red fa-2x"
  //   //             data-bs-toggle="tooltip"
  //   //             title="Delete"
  //   //           ></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //     </>
  //   //   ),
  //   //   ignoreRowClick: true,
  //   //   allowOverflow: true,
  //   //   button: true,
  //   // },
  // ];

  const handleEdit = (row) => {
    console.log(row, "data12")
    setEditModalOpen(true)
    handleUpdate(row.ID)
  }

  const columns = useMemo(() => [
    {
      header: "Tags",
      accessorKey: "Tags",
    },
    {
      header: "Tag Type",
      accessorKey: "TagType",
    },
  ]);


  const handleEditChange = (event, field) => {
    console.log(event.target.value, "handleChange")

    if (field === "Name") {
      const newdata = {
        ...formValues,
        Name: event.target.value
      }
      setFormValues(newdata)
    } else if (field === "TagType") {
      const newdata = {
        ...formValues,
        TagType: event.target.value
      }
      setFormValues(newdata)
    }
  }


  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPage, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPage, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPage, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position" >
              {/* <h3 className="page-title">Items: Tags</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "11px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Tags</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 "
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  onClick={() => handleManageDataPopup()}
                >
                  {/* <img src={PlusIcon} alt="img" className="me-1" /> Add Tag{" "} */}
                  <i className="fa fa-plus me-2 lg"></i>Add Tag
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Tag list */}
          {/* <div className="row">
            <div className="row flex-row-reverse">
              <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-50 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div>
            </div>
          </div> */}
          {/* <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0"> */}
          {/* <div className="table-responsive">
                  <DataTable
                    title=""
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    persistTableHead
                    onChangeRowsPerPage={(e) => {
                      handlePerRowsChange(1, e);
                    }}
                    onChangePage={handlePageChange}
                    dense
                  />
                </div> */}
          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            enableRowActions={checkUserPermission(PERMISSION_DELETE) || checkUserPermission(PERMISSION_EDIT)}
            positionGlobalFilter="left"
            // enableEditing
            // editDisplayMode="row"
            // onEditingRowSave={handleSaveRow}

            renderRowActionMenuItems={({ row }) => [
              checkUserPermission(PERMISSION_EDIT) && row.original.IsDefault == 0 ? (
                <MenuItem key="edit" onClick={() => handleEdit(row.original)}>
                  Edit
                </MenuItem>
              ) : null,
              checkUserPermission(PERMISSION_DELETE) && row.original.IsDefault == 0 ? (
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"
                  title="Delete"
                  data-bs-toggle="modal"
                  data-bs-target="#DeleteConfirmationModal"
                  onClick={() => handleDeletePopup(row.original.ID, "", "")}
                >
                  {/* <DeleteIcon /> */}
                  Delete
                  </MenuItem>
                ) : null,
              row.original.Attachements ? (
                <a
                  className="dropdown-item confirm-text"
                  href={row.original.Attachements}
                  target="_blank"
                  title="Attachment"
                >
                  <MenuItem title="Attachment">Attachments</MenuItem>
                </a>
              ) : (
                ""
              ),
            ]}


            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "comfortable",
              showGlobalFilter: true ,
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            
            //For color of each alternative row(Zebra-column)
            muiTableBodyProps={{
              sx: () => ({                    
                '& tr:nth-of-type(even)': {
                   backgroundColor: 'var(--datatable-row-background-color)'
                   //'rgb(237 237 233 / 63%)'
                },
                '& td': {borderRight: '1px solid var(--datatable-row-background-hover-color)',
              lineHeight: '16px',
                fontWeight: '400',
                fontSize:'12px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'},
               
                '& tr': {lineHeight: '16px',
                fontWeight: '400',
                fontSize:'12px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'}
              })
              }}
            
            muiPaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                  color: "error",
                  children: "Error loading data",
                }
                : undefined
            }
            muiTableHeadCellProps={{
              sx: theme => ({
                background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                borderRight: '1px solid var(--datatable-row-background-hover-color)',
                lineHeight: '16px',
                fontWeight: '500',
                fontSize:'14px',
                color:'var(--primary-color-800)',
                fontFamily:'Inter'
              })
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
            >
              {(table.getIsSomeRowsSelected() ||
              table.getIsAllRowsSelected()) && (
                checkUserPermission(PERMISSION_DELETE) ? (
                <Button
                  size="small"
                  class="btn btn-sm btn-secondary"
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  //only export selected rows
                  onClick={() =>
                    handleDeletePopup(
                      "",
                      table.getSelectedRowModel().rows,
                      "multipleRowInactive"
                    )
                  }
                  // startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Delete Selected
                </Button>
                ):(
                  " "
                )
               )}
                {/* <Button
                  size="small"
                  onClick={() =>
                    // setPagination({ ...pagination, pageSize: totalRows })
                    setPagination({ ...pagination, pageIndex: 0, pageSize: rowCount })
                  }
                  variant="contained"
                >
                  Get All Data
                </Button> */}
              </Box>
            )}
          />
          {/* </div> */}
          {/* </div> */}
          {/* </div> */}
          {/* /Tag list */}
        </div>
      </div>


      <Dialog open={editModalOpen}>
        <DialogTitle textAlign="center">Tags</DialogTitle>
        <DialogContent>
          <div className="modal-body">
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, errors, touched, handleChange, handleBlur }) => (
                <Form>
                  <div className="row">
                    <div className="col-12">
                      <Field
                        type="hidden"
                        className="form-control"
                        id="ID"
                        name="ID"
                        value={values.ID}
                      />
                      <div className="form-group custom-search-select">
                        <label className="col-form-label p-lg-medium">Tag Name</label>
                        <Field
                          type="text"
                          name="Name"
                          // className="form-control form-control-sm"
                          className={` ${errors.Name ? "is-invalid" : ""} form-control form-control-sm`}
                          placeholder="Enter Tag Name"
                          // value={values.Name}
                          value={formValues.Name}
                          onBlur={handleBlur}
                          onChange={(event) => handleEditChange(event, "Name")}
                        />
                        <div className="invalid-feedback">
                          {touched.Name && errors.Name ? errors.Name : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group custom-search-select">
                        <label className="col-form-label p-lg-medium">Tag Types</label>
                        <Select
                          options={options}
                          value={selectedOption}
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          onChange={(event) => setSelectedOption(event, "TagType")}
                        />
                      </div>
                    </div>

                    {/* <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div> */}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button class="btn btn-sm btn-outline-dark" onClick={() => setEditModalOpen(false)}>Cancel</Button>
          <Button
            class="btn btn-sm btn-primary"
            onClick={() => handleSubmit()}
            variant="contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Upset Model  */}
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="p-medium">Manage Tag</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="form-group">
                          <label className="col-form-label p-lg-medium">Tag Name</label>
                          <Field
                            type="text"
                            name="Name"
                            className={` ${errors.Name ? "is-invalid" : ""} form-control form-control-sm`}
                            placeholder="Enter Tag Name"
                            // value={values.Name}
                            value={formValues.Name}
                            onBlur={handleBlur}
                            onChange={(event) => handleEditChange(event, "Name")}
                          />
                          <div className="invalid-feedback">
                            {touched.Name && errors.Name ? errors.Name : ""}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="">
                          <label className="col-form-label p-lg-medium">Tag Types</label>
                          <Select
                            options={options}
                            value={selectedOption}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            className="custom-search-select"
                            onChange={(event) => setSelectedOption(event, "TagType")}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.tagBaseUrl}/tags/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default Tags;
